export const BACKEND_URL = "https://customer-portal.graywave-512feea3.westeurope.azurecontainerapps.io";
export const CLIENT_ID = "3108f1ea-b862-4ce0-9849-2778d4820ae0";
export const DOMAIN_NAME = "id.dev.gensert.tech";
export const BACKEND_CLIENT_ID = "96b1b7b5-079b-4dec-b6b6-0dc1224cb857";